import React, { useState, useEffect } from 'react';

const Carousel = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slides.length]);
  
  // Handle manual navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  
  return (
    <div className="carousel-container">
      <div 
        className="carousel-grid" 
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div className={`carousel-item ${index === currentSlide ? 'active' : ''}`} key={index}>
            <img 
              src={slide.image} 
              alt={slide.title} 
              className="carousel-img"
              onLoad={(e) => {
                // Add animation once image is loaded
                e.target.style.animation = "fadeIn 0.5s ease";
              }} 
            />
            <div className="carousel-caption">
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="carousel-dots">
        {slides.map((_, index) => (
          <div 
            className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
            key={index}
            onClick={() => goToSlide(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;